module.exports = __webpack_public_path__ + "img/1628323-80-7.48456425.png";